export default "__VITE_ASSET__liH$lZ$K__"